import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/alzguard/alzguard_2.png'
import _imports_1 from '../../assets/alzguard/alzguard_3.png'
import _imports_2 from '../../assets/alzguard/alzguard_4.png'


const _hoisted_1 = /*#__PURE__*/_createTextVNode("대화와 게임 형식으로 뇌건강 테스트 진행")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 개인 모바일 기기로 숫자게임 등 ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 다양한 게임의 형태로 뇌건강 테스트를 ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 진행할 수 있습니다. ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 또한, 어르신이 스스로, 지속적으로 ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 사용하기 쉽도록 설계했습니다. ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, sm, smAndUp } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, {
      class: "flex-row-reverse",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_subtitle, {
              class: _normalizeClass(["font-weight-medium mt-10 pb-3", { 'text-h6': _unref(xs), 'text-h5 justify-end': _unref(smAndUp) }]),
              style: {"color":"#072347","opacity":"1"}
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, {
              class: _normalizeClass(["font-weight-medium", {
          'text-subtitle-2': _unref(xs),
          'text-subtitle-1 text-right ': _unref(smAndUp),
        }]),
              style: {"line-height":"1.35"}
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { style: {"max-width":"650px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_0,
              class: _normalizeClass(["example one", { xs: _unref(xs), sm: _unref(sm) }])
            }, null, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_1,
              class: _normalizeClass(["example two", { xs: _unref(xs), sm: _unref(sm) }])
            }, null, 8, ["class"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_2,
              class: _normalizeClass(["example three", { xs: _unref(xs), sm: _unref(sm) }])
            }, null, 8, ["class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})